import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { selectGroupStageWinner } from "../../api/tournament.api";

const SelectGroupWinnerModal = ({
  open,
  handleClose,
  tournamentId,
  participants,
}) => {
  const [formData, setFormData] = useState({
    firstPlaceG1: "",
    secondPlaceG1: "",
    firstPlaceG2: "",
    secondPlaceG2: "",
  });

  const initialFormData = {
    firstPlaceG1: "",
    secondPlaceG1: "",
    firstPlaceG2: "",
    secondPlaceG2: "",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    selectGroupStageWinner(tournamentId, {
      winnerGroup1: formData.firstPlaceG1,
      winnerGroup2: formData.firstPlaceG2,
      secondGroup1: formData.secondPlaceG1,
      secondGroup2: formData.secondPlaceG2,
    })
      .then(() => setRefresh((prev) => !prev))
      .catch((error) => console.log(error));
    setFormData(initialFormData);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <form onSubmit={onSubmit}>
          <Typography variant="h3">Select Winners</Typography>
          <Typography variant="h4">Group 1</Typography>
          <div>
            <FormControl fullWidth>
              <InputLabel id="select-firstplaceg1-label">
                First Place
              </InputLabel>
              <Select
                labelId="select-firstplaceg1-label"
                id="firstPlaceG1"
                name="firstPlaceG1"
                value={formData.firstPlaceG1}
                label="First Place"
                onChange={handleChange}
              >
                {participants.map((participant) => (
                  <MenuItem key={participant.id} value={participant.id}>
                    {participant.nickname
                      ? participant.nickname
                      : participant.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div>
            <FormControl fullWidth>
              <InputLabel id="select-secondplaceg1-label">
                Second Place
              </InputLabel>
              <Select
                labelId="select-secondplaceg1-label"
                id="secondPlaceG1"
                name="secondPlaceG1"
                value={formData.secondPlaceG1}
                label="secondPlaceG1"
                onChange={handleChange}
              >
                {participants.map((participant) => (
                  <MenuItem key={participant.id} value={participant.id}>
                    {participant.nickname
                      ? participant.nickname
                      : participant.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <Typography variant="h4">Group 2</Typography>
          <div>
            <FormControl fullWidth>
              <InputLabel id="select-firstplaceg2-label">
                First Place
              </InputLabel>
              <Select
                labelId="select-firstplaceg2-label"
                id="firstPlaceG2"
                name="firstPlaceG2"
                value={formData.firstPlaceG2}
                label="First Place"
                onChange={handleChange}
              >
                {participants.map((participant) => (
                  <MenuItem key={participant.id} value={participant.id}>
                    {participant.nickname
                      ? participant.nickname
                      : participant.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div>
            <FormControl fullWidth>
              <InputLabel id="select-secondplaceg2-label">
                Second Place
              </InputLabel>
              <Select
                labelId="select-secondplaceg2-label"
                id="secondPlaceG2"
                name="secondPlaceG2"
                value={formData.secondPlaceG2}
                label="secondPlaceG2"
                onChange={handleChange}
              >
                {participants.map((participant) => (
                  <MenuItem key={participant.id} value={participant.id}>
                    {participant.nickname
                      ? participant.nickname
                      : participant.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type="submit" onClick={onSubmit}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelectGroupWinnerModal;
